// src/stations/purpleStations.js
export const PURPLE_STATIONS = [
  {
    "station_id": "WFLD",
    "lat": 12.99562730225954,
    "lng": 77.75780623738994,
    "name": "Whitefield",
    "name_kn": "ವೈಟ್‌ಫೀಲ್ಡ್",
    "name_hi": "व्हाइटफील्ड",
  },
  {
    "station_id": "CHNS",
    "lat": 12.987357313023068,
    "lng": 77.75378681426179,
    "name": "Channasandra",
    "name_kn": "ಚನ್ನಸಂದ್ರ",
    "name_hi": "चन्नसंद्र",
  },
  {
    "station_id": "KDTP",
    "lat": 12.985707912170746,
    "lng": 77.74683607990954,
    "name": "Kadugodi Tree Park",
    "name_kn": "ಕಾಡುಗೋಡಿ ಟ್ರೀ ಪಾರ್ಕ್",
    "name_hi": "कडुगोडी ट्री पार्क",
  },
  {
    "station_id": "AGHR",
    "lat": 12.987625636736137,
    "lng": 77.7377377703517,
    "name": "Agrahara",
    "name_kn": "ಅಗ್ರಹಾರ",
    "name_hi": "अग्रहार",
  },
  {
    "station_id": "SSSH",
    "lat": 12.981219959340244,
    "lng": 77.72753383545911,
    "name": "Sri Sathya Sai Hospital",
    "name_kn": "ಶ್ರೀ ಸತ್ಯ ಸಾಯಿ ಆಸ್ಪತ್ರೆ",
    "name_hi": "श्री सत्य साई हॉस्पिटल",
  },
  {
    "station_id": "NLHL",
    "lat": 12.976644473413549,
    "lng": 77.72474542277445,
    "name": "Nallur Halli",
    "name_kn": "ನಲ್ಲೂರುಹಳ್ಳಿ",
    "name_hi": "नल्लुरुहल्लि",
  },
  {
    "station_id": "KNDL",
    "lat": 12.977615215738007,
    "lng": 77.71550731471973,
    "name": "Kundalahalli",
    "name_kn": "ಕುಂದಲಹಳ್ಳಿ",
    "name_hi": "कुंदलाहल्ली",
  },
  {
    "station_id": "STMP",
    "lat": 12.980969515278773,
    "lng": 77.70871237148323,
    "name": "Seetharampalya",
    "name_kn": "ಸೀತಾರಾಂಪಾಳ್ಯ",
    "name_hi": "सीतारामपाळ्या",
  },
  {
    "station_id": "HOOD",
    "lat": 12.988781598575589,
    "lng": 77.71135790199565,
    "name": "Hoodi",
    "name_kn": "ಹೂಡಿ",
    "name_hi": "हूडी",
  },
  {
    "station_id": "GRCP",
    "lat": 12.993493267000188,
    "lng": 77.70365183152656,
    "name": "Garudacharpalya",
    "name_kn": "ಗರುಡಚಾರಪಾಳ್ಯ",
    "name_hi": "गरुडचारपाळ्या",
  },
  {
    "station_id": "SGYP",
    "lat": 12.996569493717352,
    "lng": 77.69270431527362,
    "name": "Singayyanapalya",
    "name_kn": "ಸಿಂಗಯ್ಯನಪಾಳ್ಯ",
    "name_hi": "सिंगैय्यनपाळ्या",
  },
  {
    "station_id": "KRPU",
    "lat": 12.99992337660623,
    "lng": 77.6776088972595,
    "name": "K R Pura",
    "name_kn": "ಕೆ ಆರ್ ಪುರಂ",
    "name_hi": "के आर पुरम",
  },
  {
    "station_id": "BNGL",
    "lat": 12.99637786755277,
    "lng": 77.66826581506426,
    "name": "Benniganahalli",
    "name_kn": "ಬೆನ್ನಿಗನಹಳ್ಳಿ",
    "name_hi": "बेन्निगनहल्लि",
  },
  {
    "station_id": "BYPL",
    "lat": 12.990674681516216,
    "lng": 77.65259232922982,
    "name": "Baiyappanahalli",
    "name_kn": "ಬೈಯಪ್ಪನಹಳ್ಳಿ",
    "name_hi": "बैयप्पनहल्ली",
  },
  {
    "station_id": "SVRD",
    "lat": 12.985917093435592,
    "lng": 77.6450003769173,
    "name": "Swami Vivekananda Road",
    "name_kn": "ಸ್ವಾಮಿ ವಿವೇಕಾನಂದ ರಸ್ತೆ",
    "name_hi": "स्वामी विवेकानंद रोड",
  },
  {
    "station_id": "INDR",
    "lat": 12.978260518764916,
    "lng": 77.63852445779499,
    "name": "Indiranagar",
    "name_kn": "ಇಂದಿರಾನಗರ",
    "name_hi": "इंदिरानगर",
  },
  {
    "station_id": "HLSR",
    "lat": 12.9763697238766,
    "lng": 77.626712913903,
    "name": "Halasuru",
    "name_kn": "ಹಲಸೂರು",
    "name_hi": "हलसूरु",
  },
  {
    "station_id": "TRIN",
    "lat": 12.97302866360109,
    "lng": 77.61684252553285,
    "name": "Trinity",
    "name_kn": "ಟ್ರಿನಿಟಿ",
    "name_hi": "ट्रिनिटी",
  },
  {
    "station_id": "MGRD",
    "lat": 12.975513895902,
    "lng": 77.60668761165367,
    "name": "M G Road",
    "name_kn": "ಎಂ ಜಿ ರಸ್ತೆ",
    "name_hi": "एम जी रोड",
  },
  {
    "station_id": "CBPK",
    "lat": 12.98091478079261,
    "lng": 77.59746544815259,
    "name": "Cubbon Park",
    "name_kn": "ಕಬ್ಬನ್ ಪಾರ್ಕ್",
    "name_hi": "कब्बन पार्क",
  },
  {
    "station_id": "AMBK",
    "lat": 12.979708905208735,
    "lng": 77.59263570514173,
    "name": "Ambedkar Station",
    "name_kn": "ಅಂಬೇಡ್ಕರ್ ನಿಲ್ದಾಣ",
    "name_hi": "अंबेडकर स्टेशन",
  },
  {
    "station_id": "SMVS",
    "lat": 12.974290069352909,
    "lng": 77.58394808465086,
    "name": "Sir M Visvesaraya Station",
    "name_kn": "ಸರ್ ಎಂ ವಿಶ್ವೇಶ್ವರಯ್ಯ ನಿಲ್ದಾಣ",
    "name_hi": "सर एम विश्वेश्वरैया स्टेशन",
  },
  {
    "station_id": "MJST",
    "lat": 12.975692742762831,
    "lng": 77.57284465262278,
    "name": "Majestic",
    "name_kn": "ಮಜೆಸ್ಟಿಕ್",
    "name_hi": "मजे़स्टिक",
  },
  {
    "station_id": "RWST",
    "lat": 12.975845271849582,
    "lng": 77.565754335642,
    "name": "Railway Station",
    "name_kn": "ರೈಲು ನಿಲ್ದಾಣ",
    "name_hi": "रेलवे स्टेशन",
  },
  {
    "station_id": "MGDR",
    "lat": 12.975660696200872,
    "lng": 77.55541149834026,
    "name": "Magadi Road",
    "name_kn": "ಮಗಡಿ ರಸ್ತೆ",
    "name_hi": "मगड़ी रोड",
  },
  {
    "station_id": "HSHL",
    "lat": 12.974296157827798,
    "lng": 77.54543868467049,
    "name": "Hosahalli",
    "name_kn": "ಹೊಸಹಳ್ಳಿ",
    "name_hi": "होसहल्ली",
  },
  {
    "station_id": "VJYG",
    "lat": 12.970818408682865,
    "lng": 77.53735858146575,
    "name": "Vijayanagar",
    "name_kn": "ವಿಜಯನಗರ",
    "name_hi": "विजयनगर",
  },
  {
    "station_id": "ATGP",
    "lat": 12.962106749332287,
    "lng": 77.53371311256876,
    "name": "Attiguppe",
    "name_kn": "ಅತ್ತಿಗುಪ್ಪೆ",
    "name_hi": "अत्तिगुप्पे",
  },
  {
    "station_id": "DPNL",
    "lat": 12.952217973662208,
    "lng": 77.53710196574343,
    "name": "Deepanjali Nagar",
    "name_kn": "ದೀಪಾಂಜಲಿ ನಗರ",
    "name_hi": "दीपांजलि नगर",
  },
  {
    "station_id": "MYSR",
    "lat": 12.94675771658627,
    "lng": 77.53005887923659,
    "name": "Mysuru Road",
    "name_kn": "ಮೈಸೂರು ರಸ್ತೆ",
    "name_hi": "मैसूरु रोड",
  },
  {
    "station_id": "NYDA",
    "lat": 12.941851782051183,
    "lng": 77.52518760254031,
    "name": "Nayandahalli",
    "name_kn": "ನಯಂದಹಳ್ಳಿ",
    "name_hi": "नयंदहल्लि",
  },
  {
    "station_id": "RJRN",
    "lat": 12.936736957847174,
    "lng": 77.51953890749247,
    "name": "Rajajeshwari Nagar",
    "name_kn": "ರಾಜರಾಜೇಶ್ವರಿ ನಗರ",
    "name_hi": "राजराजेश्वरी नगर",
  },
  {
    "station_id": "JNBR",
    "lat": 12.935446187562135,
    "lng": 77.51217705030243,
    "name": "Jnanabharathi",
    "name_kn": "ಜ್ಞಾನಭಾರತಿ",
    "name_hi": "ज्ञानभारती",
  },
  {
    "station_id": "PTNG",
    "lat": 12.924285109570638,
    "lng": 77.49829915158298,
    "name": "Pattanagere",
    "name_kn": "ಪಟ್ಟಣಗೆರೆ",
    "name_hi": "पट्टणगेरे",
  },
  {
    "station_id": "KENG",
    "lat": 12.914744769733002,
    "lng": 77.48772276422368,
    "name": "Kengeri Bus Terminal",
    "name_kn": "ಕೆಂಗೇರಿ ಬಸ್ ಟರ್ಮಿನಲ್",
    "name_hi": "केंगेरी बस टर्मिनल",
  },
  {
    "station_id": "KNGR",
    "lat": 12.907953617296362,
    "lng": 77.47649129957887,
    "name": "Kengeri",
    "name_kn": "ಕೆಂಗೇರಿ",
    "name_hi": "केंगेरी",
  },
  {
    "station_id": "CHLG",
    "lat": 12.897370178066199,
    "lng": 77.46117051888913,
    "name": "Challaghatta",
    "name_kn": "ಚಲ್ಲಘಟ್ಟ",
    "name_hi": "चल्लघट्टा",
  }
];
